import { pubPath } from 'Flow2/components/AdvancedBox/AdvancedHelpers/AppHelper';
import { getMfSortedData } from 'Flow2/components/CustomCollections/CustomBox/CustomTableBox/CustomTableBox';

export const getDefaultImg = () => {
    let random = Math.ceil(Math.random() * 5);
    //let imgSrc = `${pubPath()}/thumbnails/DK_Website_Personenarchiv_Platzhalter_0${random}.jpg`;
    let imgSrc = `${pubPath()}/thumbnails/DK_Website_Personenarchiv_Platzhalter_02.jpg`;
    return imgSrc;
}

export const getSubImg = () => {
    let imgSrc = `${pubPath()}/thumbnails/subtitles_white.png`;
    return imgSrc;
}

export const sortSourceFile = ({ sortedList }) => {
    let sourceIdx = sortedList.findIndex(fi => fi.sourcefile);
    if (sourceIdx > -1) {
        sortedList = [...sortedList.slice(sourceIdx, 1), ...sortedList.slice(sourceIdx + 1)];
    }
    return sortedList;
}

export const sortFiles = ({ list, props }) => {
    if (list && list.length) {
        let tmp = list.map(item => ({ ...item.data }));
        let sortedList = getMfSortedData({
            data: tmp, name: "filesize",
            sorted: false, appLang: props.language, tempConfig: props.tempConfig
        });
        sortedList = sortSourceFile({ sortedList });
        if (sortedList) {
            list = sortedList.map(item => {
                let found = list.find(li => li.data.id === item.id);
                if (found) return found;
                return item;
            })
        }
    }
    return list;
}